import {
    REQUEST_PARTNER_DISCOUNTS,
    RECEIVE_PARTNER_DISCOUNTS,
    FAILURE_PARTNER_DISCOUNTS,
    REQUEST_PARTNER_MOST_DISPLAYABLE_DISCOUNT,
    RECEIVE_PARTNER_MOST_DISPLAYABLE_DISCOUNT,
    FAILURE_PARTNER_MOST_DISPLAYABLE_DISCOUNT
} from './constants';
import _ from 'lodash';
import { CALL_API } from '../../middlewares/api';

const shouldFetchDiscounts = (state, idPartner) => {
    if (!idPartner) {
        console.error('shouldFetchDiscounts cannot take undefined partner identifier');
        return;
    }
    const discounts = state.discount.discounts[idPartner]
        ? state.discount.discounts[idPartner]
        : [];
    const fetching = state.discount.fetching;
    return fetching ? false : _.isEmpty(discounts);
};

export const fetchPartnerDiscountsIfNeeded = id => {
    return {
        [CALL_API]: {
            endpoint: `/partner/${id}/discount`,
            types: [
                REQUEST_PARTNER_DISCOUNTS,
                RECEIVE_PARTNER_DISCOUNTS,
                FAILURE_PARTNER_DISCOUNTS
            ],
            shouldCallAPI: state => shouldFetchDiscounts(state, id),
            payload: { id }
        }
    };
};

export const forceFetchDiscounts = id => {
    return {
        [CALL_API]: {
            endpoint: `/partner/${id}/discount`,
            types: [
                REQUEST_PARTNER_DISCOUNTS,
                RECEIVE_PARTNER_DISCOUNTS,
                FAILURE_PARTNER_DISCOUNTS
            ],
            payload: { id }
        }
    };
};

export const fetchPartnerMostDisplayableDiscountForUser = (id, username) => {
    return {
        [CALL_API]: {
            endpoint: `/partner/${id}/discount/${username}`,
            types: [
                REQUEST_PARTNER_MOST_DISPLAYABLE_DISCOUNT,
                RECEIVE_PARTNER_MOST_DISPLAYABLE_DISCOUNT,
                FAILURE_PARTNER_MOST_DISPLAYABLE_DISCOUNT
            ]
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/discount/actions.js